import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: (...args: any[]) => void
  }
}

const PIXEL_ID = '931318805976235'

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return

  const f = window as any
  const b = document

  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  if (s && s.parentNode) {
    s.parentNode.insertBefore(t, s)
  } else {
    ;(b.head || b.documentElement).appendChild(t)
  }

  window.fbq('init', PIXEL_ID)

  initialized = true
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel()
    trackEvent('PageView')
  }, [])

  return { trackEvent }
}
